const namespaced = true;

const state = {
  items: []
};

const getters = {
  items: state => state.items
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  }
};

const actions = {
  // eslint-disable-next-line no-unused-vars
  async fetchList({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/${classId}/course/${courseId}/name`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getList({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-section/classroom/${classId}/course/${courseId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListClassSection({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/teacher/${classId}/course/${courseId}/class-section`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListClassSectionList({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class/${classId}/course/${courseId}/list-class-section`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListStudent({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-section/student/classroom/${classId}/course/${courseId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListParent({ commit, rootGetters }, { classId, courseId }) {
    try {
      const studentId = rootGetters['Auth/student'];
      const {
        data: { data }
      } = await window.axios.get(`/api/class-section/student/${studentId.studentId}/classroom/${classId}/course/${courseId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async getListDetail({ commit }, { classSectionId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-section/${classSectionId}`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async listStudent({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-section/classroom/${classId}/course/${courseId}/student-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async listStudentSection({ commit }, { classSectionId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-section/${classSectionId}/student-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async listTeacher({ commit }, { classId, courseId }) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/class-section/classroom/${classId}/course/${courseId}/teacher-list`);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  createSection({ commit }, { payload }) {
    return window.axios.post(`/api/class-section/classroom/${payload.classId}/course/${payload.courseId}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateSection({ commit }, { payload }) {
    return window.axios.put(`/api/class-section/${payload.id}`, payload);
  },
  // eslint-disable-next-line no-unused-vars
  updateStatusClassroomCourse({ commit }, { classId, courseId, status }) {
    return window.axios.put(`/api/class/teacher/${classId}/course/${courseId}/class-section`, { classSection: status });
  },
  // eslint-disable-next-line no-unused-vars
  updateStatus({ commit }, { classSectionId, status }) {
    return window.axios.put(`/api/class-section/${classSectionId}/status`, { status });
  },
  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/class-section/${payload}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
